export default "__VITE_ASSET__c3e71d00__"